/**
 * Utility functions for handling HTML content
 */

/**
 * Strips HTML tags from a string and returns plain text
 * @param html - HTML string to sanitize
 * @returns Plain text without HTML tags
 */
export function stripHtmlTags(html: string): string {
  if (!html) return ''

  // Create a temporary DOM element to leverage browser's HTML parsing
  const temp = document.createElement('div')
  temp.innerHTML = html

  // Get text content, which automatically strips all tags
  return temp.textContent || temp.innerText || ''
}

/**
 * Strips HTML tags from an array of strings
 * @param items - Array of HTML strings to sanitize
 * @returns Array of plain text items
 */
export function stripHtmlTagsFromArray(items: (string | null | undefined)[]): string[] {
  return items
    .filter((item): item is string => Boolean(item))
    .map(item => stripHtmlTags(item).trim())
    .filter(item => item.length > 0)
}
